import { render } from "./SeoTester.vue?vue&type=template&id=a64f6498&scoped=true"
import script from "./SeoTester.vue?vue&type=script&lang=js"
export * from "./SeoTester.vue?vue&type=script&lang=js"

import "./SeoTester.vue?vue&type=style&index=0&id=a64f6498&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a64f6498"]])

export default __exports__